export default __webpack_public_path__ + "static/SourceSansPro-Regular-2002a425747f5a14e2ec5dc6387ab50d.woff2";